<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="p-3">
    <div class="p-3 align-middle d-flex">
      <i class="fas fa-exclamation-circle text-primary pr-2" style="font-size:2rem;margin-bottom:-1rem;"></i>
      <span class="line">{{message}}</span>
    </div>
    <div class="d-flex mt-2">
      <div class="my-box flex-fill pr-1">
        <div class="my-box flex-fill pr-1">
          <base-button
            block
            type="secondary"
            @click="onClickConfirmLeft"
            >{{leftButtonLabel}}</base-button
          >
        </div>
      </div>
      <div class="my-box flex-fill pr-1">
        <div class="my-box flex-fill pl-1">
          <base-button
            block
            type="primary"
            @click="onClickConfirmRight"           
            >{{rightButtonLabel}}</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data(){
    return {
      modified: false,
    }
  },
  props: {
    title: {
      type: String,
      default: "確認"
    },
    message: {
      type: String
    },
    leftButtonLabel: {
      type: String
    },
    rightButtonLabel: {
      type: String
    }
  },
  methods: {
    onClickConfirmLeft() {
      this.$emit("onClickLeftButton");
    },
    onClickConfirmRight() {
      this.$emit("onClickRightButton");
    }
  }
}
</script>
